import Keycloak from "keycloak-js";
import { isMockMode } from './mocks';
import keycloakStub from './mocks/keycloakStub';

const keycloakUrl = "REACT_APP_KEYCLOAK_URL_PLACEHOLDER";

const keycloak = isMockMode()
    ? keycloakStub
    : new Keycloak({
        url: keycloakUrl,
        realm: 'hia-realm',
        clientId: 'front-hia',
        onLoad: 'login-required',
    });

export default keycloak;


/*
axios.interceptors.request.use((config) => {
  config.headers["Authorization"] = `Bearer ${keycloak.token}`;
  return config;
});

*/
